/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewDailyRate
 */
export interface NewDailyRate {
    /**
     * 
     * @type {number}
     * @memberof NewDailyRate
     */
    value?: number;
    /**
     * 
     * @type {string}
     * @memberof NewDailyRate
     */
    currencyCode: string;
}

/**
 * Check if a given object implements the NewDailyRate interface.
 */
export function instanceOfNewDailyRate(value: object): value is NewDailyRate {
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    return true;
}

export function NewDailyRateFromJSON(json: any): NewDailyRate {
    return NewDailyRateFromJSONTyped(json, false);
}

export function NewDailyRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewDailyRate {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'currencyCode': json['currencyCode'],
    };
}

export function NewDailyRateToJSON(value?: NewDailyRate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'currencyCode': value['currencyCode'],
    };
}

